// src/scenes/feature_setup/rows.js
// feature_key stored in DB is the `page` value.
// subpages are stored in config_json as [{name, enabled}, ...]

export const ROWS_WEB = [
    { category: "Web", page: "page.admin_dashboard", subPage: "" },
    { category: "Web", page: "page.punch_clock", subPage: "" },
    { category: "Web", page: "page.availability", subPage: "" },
    { category: "Web", page: "page.planning", subPage: "" },

    { category: "Web", page: "page.shiftplan", subPage: "pre_check" },

    { category: "Web", page: "page.team", subPage: "" },
    { category: "Web", page: "page.approval_flow", subPage: "" },

    { category: "Web", page: "page.expense_management", subPage: "expense_approval" },
    { category: "Web", page: "page.expense_management", subPage: "expense_report" },

    { category: "Web", page: "page.reporting", subPage: "reporting_punch_clock" },
    { category: "Web", page: "page.reporting", subPage: "reporting_shiftplan" },
  ];
  
  
  export const ROWS_APP = [
    { category: "App", page: "page.user_dashboard", subPage: "header_planned_shift" },
    { category: "App", page: "page.user_dashboard", subPage: "header_day_view" },
    { category: "App", page: "page.user_dashboard", subPage: "punch_clock" },
    { category: "App", page: "page.user_dashboard", subPage: "expense" },
    { category: "App", page: "page.user_dashboard", subPage: "monthly_overview_shiftplan" },
    { category: "App", page: "page.user_dashboard", subPage: "monthly_overview_expense" },
  
    { category: "App", page: "page.user_dashboard", subPage: "dashboard_approval_holiday" },
    { category: "App", page: "page.user_dashboard", subPage: "dashboard_approval_shift_exchange" },
    { category: "App", page: "page.user_dashboard", subPage: "dashboard_approval_your_request" },
  
    { category: "App", page: "page.user_dashboard", subPage: "team_message" },
  
    { category: "App", page: "page.availability", subPage: "" },
  
    { category: "App", page: "page.shiftplan", subPage: "shiftplan_all" },
    { category: "App", page: "page.shiftplan", subPage: "shift_exchange" },
  ];
  
  export const ROWS_SPECIAL = [
    { category: "Special", page: "whatsapp", subPage: "" },
    { category: "Special", page: "punch_clock", subPage: "" },
    // Mitarbeitende sehen Absenzen (Krank, Unfall, ...) in App und Web nur mit
    // diesem Modul; ohne Eintrag ausgeschaltet. Siehe databases/employee_visibility.py.
    { category: "Special", page: "employee_absences", subPage: "" },
  ];
